import CbError from "@/utils/cb-error"
export default class ClientSideEncryptionHandler { 

    constructor(store, pm) {
        this.$store = store;
        this.pm = pm;
    }

    encrypt(cardData) {
        return new Promise((resolve, reject) => {
            try {
                let cseInstance = adyen.encrypt.createEncryption(this.pm.client_side_encryption_config.public_key, {});
                let cseCardData = {
                    number : cardData.number,
                    cvc : cardData.cvv,
                    holderName : this.holderName(cardData.first_name, cardData.last_name),
                    expiryMonth : `${cardData.expiry_month}`,
                    expiryYear : `${this.fourDigitYear(cardData.expiry_year)}`,
                    generationtime : this.pm.client_side_encryption_config.generation_time
                };
                this.validate(cseCardData);
                let cipherCard = cseInstance.encrypt(cseCardData);
                if(!cipherCard) {
                    throw new Error(this.$store.getters.common_translate('payment_method.common_error'));
                }
                resolve({cipherCard: cipherCard});
            } catch (error) {
                reject(new CbError(400, error, "adyen_cse"));
            }
        });
    }

    holderName(fn, ln) {
        return (fn && ln) ? `${fn} ${ln}` : (fn && !ln) ? fn : (ln && !fn) ? ln : undefined;
    }

    fourDigitYear(year) {
        if(isNaN(year)) {
            return year;
        }
        return (parseInt(year) < 100) ? (2000 + parseInt(year)) : year;
    }

    // i18n is not required for the following error text because these errors should be handle by merchant while setting up accounts.
    validate(data) {
        let missedParams = [];

        if(!data.number) {
            missedParams.push("CARD_NUMBER")
        }

        if(!data.cvc) {
            missedParams.push("CARD_CVC")
        }

        if(!data.holderName) {
            missedParams.push("CARD_HOLDER_NAME")
        }

        if(!data.expiryMonth) {
            missedParams.push("CARD_EXPIRY_MONTH")
        }

        if(!data.expiryYear) {
            missedParams.push("CARD_EXPIRY_YEAR")
        }

        if(!data.generationtime) {
            missedParams.push("GENERATION_TIME")
        }

        if(missedParams.length > 0) {
            throw new Error(`Required fields missing: [${missedParams}]`);
        }
    }

}


// WEBPACK FOOTER //
// ./src/utils/cse-handler.js